import i18n from "i18next"

import { initReactI18next } from "react-i18next"
import deAction from "./de/action.json"
import deAppend from "./de/append.json"
import deConfirm from "./de/confirm.json"
import deConjunction from "./de/conjunction.json"
import deError from "./de/error.json"
import deHelp from "./de/help.json"
import deInfo from "./de/info.json"
import deInput from "./de/input.json"
import deLabel from "./de/label.json"
import deMissing from "./de/missing.json"
import deNav from "./de/nav.json"
import deNotification from "./de/notification.json"
import dePlaceholder from "./de/placeholder.json"
import deTooltips from "./de/tooltips.json"
import deValidation from "./de/validation.json"
import deView from "./de/view.json"
import enAction from "./en/action.json"
import enAppend from "./en/append.json"
import enConfirm from "./en/confirm.json"
import enConjunction from "./en/conjunction.json"
import enError from "./en/error.json"
import enHelp from "./en/help.json"
import enInfo from "./en/info.json"
import enInput from "./en/input.json"
import enLabel from "./en/label.json"
import enMissing from "./en/missing.json"
import enNav from "./en/nav.json"
import enNotification from "./en/notification.json"
import enPlaceholder from "./en/placeholder.json"
import envTooltips from "./en/tooltips.json"
import enValidation from "./en/validation.json"
import enView from "./en/view.json"
import enCreditCard from "./en/creditCard.json"
import deCreditCard from "./de/creditCard.json"
import enCorporate from "./en/corporate.json"
import deCorporate from "./de/corporate.json"
import { enActivity, deActivity } from "@finway-group/shared/lib/locales"

const resources = {
    en: {
        nav: enNav,
        action: enAction,
        validation: enValidation,
        input: enInput,
        placeholder: enPlaceholder,
        tooltips: envTooltips,
        error: enError,
        view: enView,
        label: enLabel,
        append: enAppend,
        notification: enNotification,
        confirm: enConfirm,
        conjunction: enConjunction,
        info: enInfo,
        missing: enMissing,
        help: enHelp,
        activity: enActivity,
        creditCard: enCreditCard,
        corporate: enCorporate,
    },
    de: {
        nav: deNav,
        action: deAction,
        validation: deValidation,
        input: deInput,
        placeholder: dePlaceholder,
        tooltips: deTooltips,
        error: deError,
        view: deView,
        label: deLabel,
        append: deAppend,
        notification: deNotification,
        confirm: deConfirm,
        conjunction: deConjunction,
        info: deInfo,
        missing: deMissing,
        help: deHelp,
        activity: deActivity,
        creditCard: deCreditCard,
        corporate: deCorporate,
    },
}

i18n.use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        lng: process.env.NODE_ENV !== "test" ? navigator.language : "en",
        fallbackLng: "en",
        interpolation: {
            escapeValue: false, // react already safes from xss
        },
    })

// elementI18n.use(elementLocale);

export default i18n
